export const whatsappTemplatesPath = (connectionId = null) =>
  connectionId
    ? `/templates?canal=whatsapp&numero=${connectionId}`
    : "/templates?canal=whatsapp";

export const LINKED_ACCOUNTS_SETTINGS = { search: "?configuracion=cuentas-linkeadas" };

// Sin asignar de WhatsApp oculto a pedido del cliente (16 oct 2026).
// export const unassignedWhatsAppPath = "/sin-asignar?canal=whatsapp";
